import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportSummaryWork extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined) {
            ReportStore.loadReportDeliveryWork(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined) {
            ReportStore.loadReportDeliveryWorkRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={13}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
                <td className='text-center'>{item.title}</td>
                <td className='text-right bg-0'>{this.getNumberFormat(item.qo_count)}</td>
                <td className='text-right bg-0'>{this.getNumberFormat(item.qo_amount)}</td>
                <td className='text-right bg-1'>{this.getNumberFormat(item.work_count)}</td>
                <td className='text-right bg-1'>{this.getNumberFormat(item.work_amount)}</td>
                <td className='text-right bg-3'>{this.getNumberFormat(item.finance_count)}</td>
                <td className='text-right bg-3'>{this.getNumberFormat(item.finance_amount)}</td>
                <td className='text-right bg-2'>{this.getNumberFormat(item.close_count)}</td>
                <td className='text-right bg-2'>{this.getNumberFormat(item.close_amount)}</td>
                <td className='text-right bg-3'>{this.getNumberFormat(item.part_cost)}</td>
                <td className='text-right bg-3'>{this.getNumberFormat(item.stock_cost)}</td>
                <td className='text-right'>{this.getNumberFormat(item.percent_cost)}</td>
                <td className='text-right'>{this.getNumberFormat(parseFloat(item.qo_amount)+parseFloat(item.work_amount)+parseFloat(item.close_amount)+parseFloat(item.finance_amount)+parseFloat(item.part_cost)+parseFloat(item.stock_cost))}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    <tr>
                        <td rowSpan={2} className='text-center' style={{width:'100px'}}>ชำระเงิน<br/>ประเภท</td>
                        <td colSpan={2} className='text-center bg-0'>เสนอราคา</td>
                        <td colSpan={2} className='text-center bg-1'>สร้างงานซ่อม</td>
                        <td colSpan={2} className='text-center bg-3'>รอเก็บเงิน</td>
                        <td colSpan={2} className='text-center bg-2'>ซ่อมเสร็จ</td>
                        <td rowSpan={2} className='text-center bg-3' style={{width:'150px'}}>ต้นทุนอะไหล่ <br/> (บาท)</td>
                        <td rowSpan={2} className='text-center bg-3' style={{width:'150px'}}>ต้นทุนวัสดุ<br/>และสี (บาท)</td>
                        <td rowSpan={2} className='text-center' style={{width:'120px'}}>% ต้นทุน<br/>/ ซ่อมเสร็จ</td>
                        <td rowSpan={2} className='text-center' style={{width:'180px'}}>ส่งมอบ</td>
                    </tr>
                    <tr>
                        <td className='text-center bg-0' style={{width:'60px'}}>คัน</td>
                        <td className='text-center bg-0' style={{width:'60px'}}>จำนวนเงิน</td>
                        <td className='text-center bg-1' style={{width:'60px'}}>คัน</td>
                        <td className='text-center bg-1' style={{width:'60px'}}>จำนวนเงิน</td>
                        <td className='text-center bg-3' style={{width:'60px'}}>คัน</td>
                        <td className='text-center bg-3' style={{width:'60px'}}>จำนวนเงิน</td>
                        <td className='text-center bg-2' style={{width:'60px'}}>คัน</td>
                        <td className='text-center bg-2' style={{width:'60px'}}>จำนวนเงิน</td>
                    </tr>  
                    {this.renderRowData(item,index)}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportSummaryWork.defaultProps = {
    title: 'ตารางรายงานสรุปรถเข้าออก',
    mode: '',
    workNo: ''
  }
  export default PrintReportSummaryWork;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportSummaryWork.js